import React from 'react'
import PropTypes from 'prop-types'
import { INIT_APP_PARAMS, SEND_WINDOW_INFO } from '../../actions'

const withSiteAndLocale = (Component) => {
  const wrapped = class extends React.Component {
    componentDidMount() {
      this.props.handleAction(INIT_APP_PARAMS, this.props.location.query)
      this.props.handleAction(SEND_WINDOW_INFO, {scrollHeight: document.body.scrollHeight, scrollTop: true})
      this.props.router.listen(() => setTimeout(() => this.props.handleAction(SEND_WINDOW_INFO, {scrollHeight: document.body.scrollHeight, scrollTop: true}), 300))
    }

    render() {
      return (
        <Component
          {...this.props}
          {...this.state}
        />
      )
    }
  }

  wrapped.propTypes = {
    handleAction: PropTypes.func,
    location: PropTypes.shape({
      query: PropTypes.object.isRequired,
    }).isRequired,
  }

  wrapped.defaultProps = {
    handleAction: PropTypes.func,
  }

  return wrapped
}

withSiteAndLocale.propTypes = {
  Component: PropTypes.element,
}

withSiteAndLocale.defaultProps = {
  Component: PropTypes.element,
}

export default withSiteAndLocale



// WEBPACK FOOTER //
// ./src/components/hoc/site-and-locale.js